export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.16-0930.19",
  commitId: "fa15b58bbd2d6e1b0d36d50d84c5de188793f684",
  commitTime: "2026-07-16T09:30:19.000Z",
});
